import React from 'react';
import {DatePicker, TextFieldCommon} from "../formikFormInputs";
import {Label} from "../formInputs";
import {asDbDateFormat} from "../../utils/dateUtils";
import {CommonProps} from "./index";

interface DateMonthProps extends CommonProps {
}

const DateMonth = (formProps: DateMonthProps) => {
    const {handleBlur, handleChange, label, name, setFieldValue, values} = formProps;
    const commonVariantProps = {variant: "outlined"};
    const field = {
        cb: (date: string) => setFieldValue(name, asDbDateFormat(date, "YYYY-MM")),
        component: DatePicker,
        disableFuture: true,
        label: <Label label={label}/>,
        name: name,
        type: 'month',
        variant: "outlined",
        view: ['month', 'year'],
    };
    return (
            <TextFieldCommon
                    {...commonVariantProps}
                    {...field}
                    autoComplete="off"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    values={values}
            />
    );
};

export default DateMonth;
